/**
 * P4-12: App 对话框。
 *
 * 取代 index.html `#appDiv` 的移动应用推广文案。
 */
import { useDialog } from "../components/Dialog";

export default function AppDialog() {
  const { closeTopDialog } = useDialog();

  return (
    <div className="app-dialog">
      <p>Kittens Game Mobile has been released! Click on a link to follow:</p>
      <p>
        <a
          id="appAndroid"
          href="https://play.google.com/store/apps/details?id=com.nuclearunicorn.kittensgame&hl=en"
          target="_blank"
          rel="noreferrer"
        >
          Android
        </a>
        {" | "}
        <a
          id="appIOS"
          href="https://itunes.apple.com/us/app/kittens-game/id1198099725?mt=8"
          target="_blank"
          rel="noreferrer"
        >
          iOS
        </a>
      </p>
      <button type="button" onClick={closeTopDialog}>Close</button>
    </div>
  );
}
